BasketListItemController.$inject = ['$state', 'BasketService', 'BasketConfig'];
export default function BasketListItemController($state, BasketService, BasketConfig) {
    var ctrl = this;

    ctrl.$onInit = function() {
        ctrl.catalogid = BasketConfig.catalogid;
    };

    ctrl.remove = function() {
        if (ctrl.item.id) {
            BasketService.remove({id: ctrl.item.uuid}).$promise.then(function(response) {
                $state.go($state.current, {}, {reload: true});
            });
        }
    }
}
